import React, { useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./testimonials.css";

const Testimonials: React.FC = () => {
  const [active, setActive] = useState("Students");

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    arrows: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const typeOfTestimonial = ["Students", "Parents"];

  const testimonials = [
    {
      id: 1,
      name: "Mr. and Mrs. Sharma",
      img: "https://www.growniverse.com/images//MrAndMrsSharma.webp",
      testimonial:
        "We've Seen Significant Improvement in Our Both Children's Confidence, Communication And essential life skills. Highly Recommend to other Parents",
      type: "Parents",
    },
    {
      id: 2,
      name: "Mrs. Sharda Devi",
      img: "https://www.growniverse.com/images//ShardaDevi.webp",
      testimonial:
        "The Mentors at Growniverse Provides The Best Environment Possible For Our Both Children's Progress.",
      type: "Parents",
    },
    {
      id: 3,
      name: "Mrs. Reena Devi",
      img: "https://www.growniverse.com/images//ReenaDevi.webp",
      testimonial:
        "Growniverse has an Excellent Communication System, Which Ensure that Parents are always aware of their Child shedule and performance",
      type: "Parents",
    },
    {
      id: 4,
      name: "Mrs Reshma Devi",
      img: "https://www.growniverse.com/images//ReshmaDevi.webp",
      testimonial:
        "Growniverse has Exceeded Our Expectations in every way. The Quality Education and Support has made a Significant Different in My Daughter's Life",
      type: "Parents",
    },
    {
      id: 5,
      name: "Karan Rajput",
      img: "https://www.growniverse.com/images//KaranRajput.webp",
      testimonial:
        "Growniverse is where Minds are opened and Future are Shaped.",
      type: "Students",
    },
    {
      id: 6,
      name: "Sonia Choudhary",
      img: "https://www.growniverse.com/images//SoniaChoudhary.webp",
      testimonial:
        "I am Greatful for the Skills, Knowledge and Confidence Growniverse Provide to me.",
      type: "Students",
    },
    {
      id: 7,
      name: "Bhushan Sharma",
      img: "https://www.growniverse.com/images//BhushanSharma.webp",
      testimonial:
        "You are More than a Digital Learning Platform,Your Environment is a Blessing in My Life.",
      type: "Students",
    },
    {
      id: 8,
      name: "Kajal",
      img: "https://www.growniverse.com/images//Kajal.webp",
      testimonial:
        "I am truly grateful and honored to be a part of the incredible Growniverse.",
      type: "Students",
    },
    {
      id: 9,
      name: "Jiya Sharma",
      img: "https://www.growniverse.com/images//JiyaSharma.webp",
      testimonial:
        "I improve my Communication Skills very much from Growniverse.",
      type: "Students",
    },
  ];

  const filteredTestimonials = testimonials.filter(
    (testimonial) => testimonial.type === active
  );

  return (
    <>
      <section
        className="testimonial-section"
        style={{
          position: "relative",
          overflow: "hidden",
          padding: "65px 0 55px",

          background:
            "linear-gradient(135deg, #03050a 0%, #070b14 50%, #03050a 100%)",

          borderTop: "1px solid rgba(0,246,255,0.12)",
          borderBottom: "1px solid rgba(139,92,255,0.12)",

          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.025)",
        }}
      >
        {/* =========================
            BACKGROUND GRID
        ========================= */}

        <div
          style={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",

            opacity: 0.18,

            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",

            backgroundSize: "35px 35px",
          }}
        />

        {/* =========================
            CYAN GLOW
        ========================= */}

        <div
          style={{
            position: "absolute",
            width: "320px",
            height: "320px",

            left: "-180px",
            top: "-120px",

            borderRadius: "50%",

            background: "rgba(0,246,255,0.055)",

            filter: "blur(100px)",

            pointerEvents: "none",
          }}
        />

        {/* =========================
            PURPLE GLOW
        ========================= */}

        <div
          style={{
            position: "absolute",
            width: "320px",
            height: "320px",

            right: "-180px",
            bottom: "-120px",

            borderRadius: "50%",

            background: "rgba(139,92,255,0.065)",

            filter: "blur(100px)",

            pointerEvents: "none",
          }}
        />

        {/* =========================
            CONTENT
        ========================= */}

        <div
          className="container"
          style={{
            position: "relative",
            zIndex: 2,
          }}
        >
          {/* =========================
              HEADER
          ========================= */}

          <div
            style={{
              textAlign: "center",
              maxWidth: "720px",
              margin: "0 auto 28px",
            }}
          >
            {/* LABEL */}

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",

                padding: "6px 14px",

                marginBottom: "12px",

                borderRadius: "30px",

                border:
                  "1px solid rgba(0,246,255,0.22)",

                background:
                  "rgba(0,246,255,0.025)",

                color: "#00f6ff",

                fontSize: "10px",

                fontWeight: 700,

                letterSpacing: "2px",

                textTransform: "uppercase",

                boxShadow:
                  "0 0 18px rgba(0,246,255,0.04)",
              }}
            >
              <span
                style={{
                  width: "5px",
                  height: "5px",
                  borderRadius: "50%",

                  background: "#00f6ff",

                  boxShadow:
                    "0 0 9px #00f6ff",
                }}
              />

              Growniverse Voices
            </div>

            {/* HEADING */}

            <h2
              style={{
                margin: 0,

                color: "#ffffff",

                fontSize:
                  "clamp(27px, 4vw, 40px)",

                fontWeight: 800,

                letterSpacing: "-0.5px",

                lineHeight: 1.2,

                textShadow:
                  "0 0 20px rgba(255,255,255,0.10), 0 0 30px rgba(0,246,255,0.06)",
              }}
            >
              What People Feel About Us
            </h2>

            {/* LINE */}

            <div
              style={{
                width: "65px",
                height: "2px",

                margin: "13px auto 0",

                borderRadius: "10px",

                background:
                  "linear-gradient(90deg, transparent, #00f6ff, transparent)",

                boxShadow:
                  "0 0 10px rgba(0,246,255,0.55)",
              }}
            />

            <p
              style={{
                margin: "13px auto 0",

                color: "#9daabd",

                fontSize: "13px",

                lineHeight: 1.6,
              }}
            >
              Your reviews are highly valued by us. Thank you for
              taking the time to share your thoughts.
            </p>
          </div>

          {/* =========================
              FILTERS
          ========================= */}

          <div
            style={{
              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              gap: "8px",

              flexWrap: "wrap",

              marginBottom: "22px",
            }}
          >
            {typeOfTestimonial.map((type) => {
              const isActive = active === type;

              return (
                <button
                  key={type}
                  type="button"
                  onClick={() => setActive(type)}
                  style={{
                    position: "relative",

                    minWidth: "105px",

                    padding: "8px 18px",

                    borderRadius: "25px",

                    border: isActive
                      ? "1px solid rgba(0,246,255,0.60)"
                      : "1px solid rgba(255,255,255,0.10)",

                    background: isActive
                      ? "linear-gradient(135deg, rgba(0,246,255,0.12), rgba(139,92,255,0.08))"
                      : "rgba(255,255,255,0.02)",

                    color: isActive
                      ? "#00f6ff"
                      : "#aeb9c9",

                    fontSize: "11px",

                    fontWeight: 700,

                    letterSpacing: "0.7px",

                    cursor: "pointer",

                    transition: "all 0.25s ease",

                    boxShadow: isActive
                      ? "0 0 18px rgba(0,246,255,0.08)"
                      : "none",
                  }}
                >
                  {type}

                  {isActive && (
                    <span
                      style={{
                        position: "absolute",

                        left: "25%",
                        right: "25%",

                        bottom: "-1px",

                        height: "2px",

                        borderRadius: "10px",

                        background: "#00f6ff",

                        boxShadow:
                          "0 0 8px #00f6ff",
                      }}
                    />
                  )}
                </button>
              );
            })}
          </div>

          {/* =========================
              SLIDER
          ========================= */}

          <div
            className="testimonial-slider-wrapper"
            style={{
              position: "relative",

              padding: "0 5px 35px",
            }}
          >
            <Slider {...settings}>
              {filteredTestimonials.map((testimonial) => (
                <div
                  key={testimonial.id}
                  style={{
                    padding: "8px",
                  }}
                >
                  {/* =====================
                      CARD
                  ===================== */}

                  <div
                    style={{
                      position: "relative",

                      height: "285px",

                      display: "flex",

                      flexDirection: "column",

                      overflow: "hidden",

                      borderRadius: "16px",

                      background:
                        "linear-gradient(145deg, rgba(16,23,37,0.97), rgba(6,10,18,0.99))",

                      border:
                        "1px solid rgba(0,246,255,0.12)",

                      boxShadow:
                        "0 15px 40px rgba(0,0,0,0.45), 0 0 20px rgba(0,246,255,0.035)",

                      transition:
                        "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform =
                        "translateY(-6px)";

                      e.currentTarget.style.borderColor =
                        "rgba(0,246,255,0.38)";

                      e.currentTarget.style.boxShadow =
                        "0 20px 50px rgba(0,0,0,0.55), 0 0 28px rgba(0,246,255,0.09)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform =
                        "translateY(0)";

                      e.currentTarget.style.borderColor =
                        "rgba(0,246,255,0.12)";

                      e.currentTarget.style.boxShadow =
                        "0 15px 40px rgba(0,0,0,0.45), 0 0 20px rgba(0,246,255,0.035)";
                    }}
                  >
                    {/* TOP NEON LINE */}

                    <div
                      style={{
                        position: "absolute",

                        top: 0,

                        left: "20%",
                        right: "20%",

                        height: "2px",

                        background:
                          "linear-gradient(90deg, transparent, #00f6ff, #8b5cff, transparent)",

                        boxShadow:
                          "0 0 10px rgba(0,246,255,0.65)",

                        zIndex: 2,
                      }}
                    />

                    {/* CARD CONTENT */}

                    <div
                      style={{
                        padding: "20px 20px 17px",

                        display: "flex",

                        flexDirection: "column",

                        alignItems: "center",

                        textAlign: "center",

                        flex: 1,
                      }}
                    >
                      {/* QUOTE */}

                      <div
                        style={{
                          alignSelf: "flex-start",

                          color: "#00f6ff",

                          fontSize: "28px",

                          lineHeight: "18px",

                          fontWeight: 800,

                          opacity: 0.75,

                          marginBottom: "4px",
                        }}
                      >
                        “
                      </div>

                      {/* IMAGE */}

                      <div
                        style={{
                          width: "70px",

                          height: "70px",

                          padding: "2px",

                          borderRadius: "50%",

                          background:
                            "conic-gradient(#00f6ff, #8b5cff, #00f6ff)",

                          boxShadow:
                            "0 0 18px rgba(0,246,255,0.12)",

                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",

                            height: "100%",

                            borderRadius: "50%",

                            overflow: "hidden",

                            background: "#080c15",

                            border:
                              "2px solid #080c15",
                          }}
                        >
                          <img
                            src={testimonial.img}
                            alt={testimonial.name}
                            style={{
                              width: "100%",
                              height: "100%",

                              objectFit: "cover",

                              display: "block",
                            }}
                          />
                        </div>
                      </div>

                      {/* TESTIMONIAL */}

                      <p
                        style={{
                          margin: 0,

                          color: "#cbd5e1",

                          fontSize: "12px",

                          lineHeight: 1.6,

                          fontWeight: 400,

                          flex: 1,

                          display: "-webkit-box",

                          WebkitLineClamp: 4,

                          WebkitBoxOrient:
                            "vertical",

                          overflow: "hidden",
                        }}
                      >
                        {testimonial.testimonial}
                      </p>

                      {/* NAME */}

                      <div
                        style={{
                          width: "100%",

                          marginTop: "12px",

                          paddingTop: "10px",

                          borderTop:
                            "1px solid rgba(255,255,255,0.06)",
                        }}
                      >
                        <h5
                          style={{
                            margin: 0,

                            color: "#ffffff",

                            fontSize: "13px",

                            fontWeight: 700,

                            letterSpacing: "0.2px",
                          }}
                        >
                          {testimonial.name}
                        </h5>

                        <span
                          style={{
                            display: "block",

                            marginTop: "4px",

                            color:
                              testimonial.type ===
                              "Students"
                                ? "#00f6ff"
                                : "#a78bfa",

                            fontSize: "8px",

                            fontWeight: 700,

                            letterSpacing: "1.4px",

                            textTransform:
                              "uppercase",
                          }}
                        >
                          {testimonial.type}
                        </span>
                      </div>
                    </div>

                    {/* BOTTOM GLOW */}

                    <div
                      style={{
                        position: "absolute",

                        left: "20%",
                        right: "20%",

                        bottom: "-18px",

                        height: "30px",

                        background:
                          "rgba(0,246,255,0.055)",

                        filter: "blur(22px)",

                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* BOTTOM LINE */}

        <div
          style={{
            position: "absolute",

            bottom: 0,

            left: "20%",
            right: "20%",

            height: "1px",

            background:
              "linear-gradient(90deg, transparent, rgba(0,246,255,0.45), transparent)",

            pointerEvents: "none",
          }}
        />
      </section>

      {/* =========================
          SLICK CSS
      ========================= */}

      <style>
        {`
          .testimonial-slider-wrapper .slick-list {
            padding-top: 5px;
            padding-bottom: 5px;
          }

          .testimonial-slider-wrapper .slick-track {
            display: flex;
            align-items: stretch;
          }

          .testimonial-slider-wrapper .slick-slide {
            height: auto;
          }

          .testimonial-slider-wrapper .slick-slide > div {
            height: 100%;
          }

          .testimonial-slider-wrapper .slick-dots {
            bottom: -5px;
          }

          .testimonial-slider-wrapper .slick-dots li {
            margin: 0 2px;
          }

          .testimonial-slider-wrapper .slick-dots li button:before {
            color: #64748b;
            opacity: 0.65;
            font-size: 8px;
          }

          .testimonial-slider-wrapper
            .slick-dots
            li.slick-active
            button:before {
            color: #00f6ff;
            opacity: 1;
            text-shadow: 0 0 8px #00f6ff;
          }

          .testimonial-slider-wrapper .slick-prev,
          .testimonial-slider-wrapper .slick-next {
            z-index: 5;

            width: 38px;
            height: 38px;

            border-radius: 50%;

            border: 1px solid rgba(0,246,255,0.22);

            background: rgba(4,8,16,0.90);

            box-shadow:
              0 0 16px rgba(0,246,255,0.06);

            transition: all 0.25s ease;
          }

          .testimonial-slider-wrapper .slick-prev:hover,
          .testimonial-slider-wrapper .slick-next:hover {
            border-color: rgba(0,246,255,0.55);

            background: rgba(0,246,255,0.07);

            box-shadow:
              0 0 18px rgba(0,246,255,0.16);
          }

          .testimonial-slider-wrapper .slick-prev {
            left: -42px;
          }

          .testimonial-slider-wrapper .slick-next {
            right: -42px;
          }

          .testimonial-slider-wrapper .slick-prev:before,
          .testimonial-slider-wrapper .slick-next:before {
            color: #00f6ff;

            font-size: 16px;

            opacity: 1;
          }

          @media (max-width: 1100px) {
            .testimonial-slider-wrapper .slick-prev {
              left: -15px;
            }

            .testimonial-slider-wrapper .slick-next {
              right: -15px;
            }
          }

          @media (max-width: 768px) {
            .testimonial-section {
              padding: 50px 0 45px !important;
            }

            .testimonial-slider-wrapper {
              padding-left: 5px;
              padding-right: 5px;
            }

            .testimonial-slider-wrapper .slick-slide {
              padding: 0 4px;
            }

            .testimonial-slider-wrapper .slick-dots {
              bottom: -8px;
            }
          }
        `}
      </style>
    </>
  );
};

export default Testimonials;